export default "__VITE_ASSET__BlI$gllZ__"